import React from "react";
import { connect } from "react-redux";
import { DrawerPadrao } from "../../../components/DialogPadrao";

function DanfeViewer({ visible, empresaPk, chave, onCancel, tipo = 'danfe', ...props }) {

  return <DrawerPadrao visible={visible} onCancel={onCancel} width={1000} bodyStyle={{ padding: 0 }} title={'Danfe ' + chave} >
    {visible && <iframe src={`${props.nfeViewer}/${tipo}/${empresaPk}/${chave}`} style={{ minHeight: 'calc(100vh - 50px)', width: "100%", border: "none" }} />}
  </DrawerPadrao>;
}

const mapStateToProps = state => ({ nfeViewer: state.dados.nfeViewer });

export default connect(mapStateToProps, {})(DanfeViewer);
